import PropTypes from 'prop-types';
import { tiempoRelativo } from '../../features/tickets';

const TicketHistorial = ({ entradas }) => (
  <section className="tickets-historial">
    <p className="tickets-props__caption">Historial</p>
    {entradas.length === 0 ? (
      <p className="tickets-historial__vacio">Sin cambios registrados.</p>
    ) : (
      <ul className="tickets-historial__list">
        {entradas.map((h) => (
          <li key={h.id} className="tickets-historial__item">
            <span className="tickets-historial__txt">
              <strong>{h.usuario || 'Sistema'}</strong> cambió <em>{h.campo}</em>
              {': '}
              {h.valor_anterior || '—'} → {h.valor_nuevo || '—'}
            </span>
            <span className="tickets-historial__tiempo">{tiempoRelativo(h.creado_en)}</span>
          </li>
        ))}
      </ul>
    )}
  </section>
);

TicketHistorial.propTypes = {
  entradas: PropTypes.arrayOf(PropTypes.object),
};

TicketHistorial.defaultProps = {
  entradas: [],
};

export default TicketHistorial;
